import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from './ui/command';

const PAGES = [
  { label: 'Dashboard', path: '/dashboard', icon: '⊞' },
  { label: 'GTM Agent', path: '/agent', icon: '🤖' },
  { label: 'Deal Pipeline', path: '/deals', icon: '💰' },
  { label: 'Accounts', path: '/accounts', icon: '🏢' },
  { label: 'Follow-ups', path: '/crm-tasks', icon: '✅' },
  { label: 'People Intel', path: '/people', icon: '👥' },
  { label: 'Signal Center', path: '/signals', icon: '📡' },
  { label: 'Lead Scoring', path: '/scoring', icon: '🎯' },
  { label: 'Intelligence', path: '/intelligence', icon: '🧠' },
  { label: 'Competitors', path: '/competitors', icon: '⚔️' },
  { label: 'Import Intel', path: '/ingestion', icon: '📥' },
  { label: 'Foundation', path: '/foundation', icon: '🏛' },
  { label: 'Sources', path: '/sources', icon: '📡' },
  { label: 'Assets', path: '/assets', icon: '📁' },
  { label: 'Analysis', path: '/analysis', icon: '🔬' },
  { label: 'Campaigns', path: '/campaigns', icon: '🎯' },
  { label: 'Draft Factory', path: '/drafts', icon: '✍️' },
  { label: 'Approvals', path: '/approvals', icon: '✅' },
  { label: 'Publishing', path: '/publishing', icon: '📢' },
  { label: 'Apollo Leads', path: '/apollo', icon: '🔭' },
  { label: 'Multichannel', path: '/multichannel', icon: '🌐' },
  { label: 'PromptOps', path: '/promptops', icon: '⚙️' },
  { label: 'Learning Loop', path: '/learning', icon: '🔄' },
  { label: 'Agent Ops Console', path: '/agent-ops', icon: '🖥️' },
  { label: 'Token Usage', path: '/token-usage', icon: '📊' },
  { label: 'Team Settings', path: '/settings/team', icon: '👥' },
  { label: 'Org Settings', path: '/settings/organization', icon: '🏢' },
  { label: 'Upgrade Plan', path: '/upgrade', icon: '⬆️' },
  { label: 'Channels Hub', path: '/channels', icon: '📡' },
  { label: 'Integrations', path: '/integrations', icon: '🔌' },
];

const QUICK_ACTIONS = [
  { label: 'New Deal', path: '/deals?action=new', icon: '➕' },
  { label: 'New Account', path: '/accounts?action=new', icon: '➕' },
  { label: 'New Person', path: '/people?action=new', icon: '➕' },
];

export default function CommandPalette() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const runAction = useCallback(
    (path) => {
      setOpen(false);
      setQuery('');
      navigate(path);
    },
    [navigate]
  );

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput
        placeholder="Search pages, actions..."
        value={query}
        onValueChange={setQuery}
      />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>

        <CommandGroup heading="Pages">
          {PAGES.map((page) => (
            <CommandItem
              key={page.path}
              value={page.label}
              onSelect={() => runAction(page.path)}
            >
              <span style={{ marginRight: 8 }}>{page.icon}</span>
              {page.label}
            </CommandItem>
          ))}
        </CommandGroup>

        <CommandGroup heading="Quick Actions">
          {QUICK_ACTIONS.map((action) => (
            <CommandItem
              key={action.path}
              value={action.label}
              onSelect={() => runAction(action.path)}
            >
              <span style={{ marginRight: 8 }}>{action.icon}</span>
              {action.label}
            </CommandItem>
          ))}
        </CommandGroup>

        {query.length >= 3 && (
          <CommandGroup heading="Search">
            <CommandItem
              value={`search-${query}`}
              onSelect={() =>
                runAction(`/accounts?q=${encodeURIComponent(query)}`)
              }
            >
              🔍 Search for '{query}'...
            </CommandItem>
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
